export const cloudCostZh = {
  "cost.metric.compute_unit_seconds": "计算资源",
  "cost.metric.root_branch_bytes_month": "主分支存储",
  "cost.metric.child_branch_bytes_month": "子分支存储",
  "cost.metric.instant_restore_bytes_month": "即时恢复历史",
  "cost.metric.snapshot_storage_bytes_month": "快照存储",
  "cost.metric.public_network_transfer_bytes": "公网传输",
  "cost.metric.private_network_transfer_bytes": "私网传输",
  "cost.metric.extra_branches_month": "额外分支",
  "cost.metric.functions_active_capacity_microseconds": "函数活跃计算",
  "cost.metric.functions_waiting_capacity_microseconds": "函数等待计算",
  "cost.metric.functions_invocations": "函数调用",
  "cost.metric.functions_egress_bytes": "函数流量",

  "cost.detail_day": "明细日期（可留空）",
  "cost.events": "Cloudflare 账单流水（API）",
  "cost.events_note":
    "保留原始事件类型，账单生成与付款可能对应同一笔费用，流水不再次计入用量总额。",
  "cost.invoices": "已核验账单 · 按出账月份",
  "cost.invoice_note":
    "账单总额不与上方用量费用相加。账单从供应商原件核验导入，历史账单条目未齐时明确显示差额；用量费用通过 API 同步。",
  "cost.invoice_not_imported": "本月尚未导入账单；不代表没有扣款。",
  "cost.invoice_unavailable": "账单存储暂不可用。",
  "cost.reconciled": "明细与账单总额差额（已对平）",
  "cost.unreconciled": "待核实 / 缺失明细金额",
  "cost.title": "云服务费用监测",
  "cost.description":
    "Neon · Cloudflare / UTC 账期 / 每 15 分钟按需同步，页面关闭时不轮询",
  "cost.month": "月份",
  "cost.day": "按日",
  "cost.monthly": "按月",
  "cost.refresh": "同步最新数据",
  "cost.export": "导出明细 CSV",
  "cost.known": "已获取用量费用",
  "cost.unknown": "金额待核实项",
  "cost.rows": "费用明细项",
  "cost.notice":
    "用量费用不等于已扣款。上方仅汇总已获取用量；固定订阅、税费、抵扣请查下方账单，自动同步覆盖尚不完整。未知金额不会当作零。",
  "cost.date": "日期 / 账期",
  "cost.provider": "供应商",
  "cost.service": "计费项目 / 资源",
  "cost.quantity": "用量",
  "cost.amount": "金额（美元）",
  "cost.basis": "依据",
  "cost.empty": "当前筛选没有已获取的数据；不代表零消费。",
  "cost.ok": "已同步",
  "cost.not_configured": "尚未配置只读凭证",
  "cost.unavailable": "同步失败",
  "cost.estimate": "按单价估算",
  "cost.provider_usage": "供应商用量记录",
  "cost.invoice": "账单",
  "cost.updated": "最后成功同步",
  "cost.unknown_value": "待核实",
  "cost.all": "全部供应商",
  "cost.error": "无法获取费用数据，请重试。",
  "cost.partial": "部分覆盖",
  "cost.month_only": "供应商仅提供月度数据，不能拆成每日实际费用。",
};
export const cloudCostEn: Record<keyof typeof cloudCostZh, string> = {
  "cost.metric.compute_unit_seconds": "Compute",
  "cost.metric.root_branch_bytes_month": "Root branch storage",
  "cost.metric.child_branch_bytes_month": "Child branch storage",
  "cost.metric.instant_restore_bytes_month": "Instant restore history",
  "cost.metric.snapshot_storage_bytes_month": "Snapshot storage",
  "cost.metric.public_network_transfer_bytes": "Public network transfer",
  "cost.metric.private_network_transfer_bytes": "Private network transfer",
  "cost.metric.extra_branches_month": "Extra branches",
  "cost.metric.functions_active_capacity_microseconds":
    "Functions active compute",
  "cost.metric.functions_waiting_capacity_microseconds":
    "Functions waiting compute",
  "cost.metric.functions_invocations": "Function invocations",
  "cost.metric.functions_egress_bytes": "Function egress",

  "cost.detail_day": "Detail date (optional)",
  "cost.events": "Cloudflare billing events (API)",
  "cost.events_note":
    "Original event types are retained. Invoice and payment events may refer to the same charge, so events are not added to usage totals.",
  "cost.invoices": "Verified invoices · issue month",
  "cost.invoice_note":
    "Invoice totals are not added to usage costs above. Invoices are imported from verified originals; missing itemization appears as an unreconciled difference. Usage synchronizes through APIs.",
  "cost.invoice_not_imported":
    "No invoice imported for this month. This does not imply no payment.",
  "cost.invoice_unavailable": "Invoice storage is unavailable.",
  "cost.reconciled": "Itemization difference (reconciled)",
  "cost.unreconciled": "Unreconciled / missing itemization",
  "cost.title": "Cloud cost monitor",
  "cost.description":
    "Neon · Cloudflare / UTC periods / On-demand sync every 15 minutes; no polling while closed",
  "cost.month": "Month",
  "cost.day": "Daily",
  "cost.monthly": "Monthly",
  "cost.refresh": "Sync latest data",
  "cost.export": "Export CSV",
  "cost.known": "Available usage costs",
  "cost.unknown": "Unpriced items",
  "cost.rows": "Cost line items",
  "cost.notice":
    "Usage costs are not payments. The total includes retrieved usage only. See invoices below for subscriptions, taxes and credits; automatic coverage is incomplete. Unknown amounts are never treated as zero.",
  "cost.date": "Date / billing period",
  "cost.provider": "Provider",
  "cost.service": "Service / resource",
  "cost.quantity": "Usage",
  "cost.amount": "Amount (USD)",
  "cost.basis": "Basis",
  "cost.empty":
    "No data retrieved for this selection. This does not mean zero spend.",
  "cost.ok": "Synced",
  "cost.not_configured": "Read-only credentials not configured",
  "cost.unavailable": "Sync failed",
  "cost.estimate": "Rate estimate",
  "cost.provider_usage": "Provider consumption record",
  "cost.invoice": "Invoice",
  "cost.updated": "Last successful sync",
  "cost.unknown_value": "Unverified",
  "cost.all": "All providers",
  "cost.error": "Unable to retrieve costs. Please retry.",
  "cost.partial": "Partial coverage",
  "cost.month_only":
    "Only monthly data is available; it cannot be split into actual daily costs.",
};
